import { formatMoneyCents } from "../../lib/money.js";

export default function ConnectBalancePanel({ balance, connect, isLoading }) {
  if (isLoading) {
    return (
      <div className="mt-4 grid gap-3 sm:grid-cols-2">
        <div className="h-20 animate-pulse rounded-[14px] bg-white/5" />
        <div className="h-20 animate-pulse rounded-[14px] bg-white/5" />
      </div>
    );
  }

  if (!connect?.ready || !balance) return null;

  const currency = balance.currency ?? "cad";

  return (
    <div className="mt-4 space-y-4">
      <div className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-[14px] border border-hc-surface-border bg-hc-page-shell px-4 py-3.5">
          <p className="text-xs text-hc-text-dim">Available</p>
          <p className="mt-1 text-lg font-semibold text-hc-text">
            {formatMoneyCents(balance.availableCents, currency)}
          </p>
        </div>
        <div className="rounded-[14px] border border-hc-surface-border bg-hc-page-shell px-4 py-3.5">
          <p className="text-xs text-hc-text-dim">Pending</p>
          <p className="mt-1 text-lg font-semibold text-hc-text">
            {formatMoneyCents(balance.pendingCents, currency)}
          </p>
        </div>
      </div>

      <div className="flex flex-wrap gap-3 text-xs text-hc-text-dim">
        <span>
          Charges {connect.chargesEnabled ? "enabled" : "disabled"}
        </span>
        <span aria-hidden="true">·</span>
        <span>
          Payouts {connect.payoutsEnabled ? "enabled" : "disabled"}
        </span>
      </div>
    </div>
  );
}
